function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Item, HeaderButton as RNHeaderButton, HeaderButtons as RNHeaderButtons } from "react-navigation-header-buttons";
import { Icon } from "./Icon";
// define IconComponent, color, sizes and OverflowIcon in one place
var HeaderButton = function(props) {
    return /*#__PURE__*/ _jsx(RNHeaderButton, _object_spread_props(_object_spread({
        IconComponent: Icon
    }, props), {
        role: "button"
    }));
};
/**
 * Renders `HeaderItem`s for use in a screen header.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-83}
 */ export var HeaderButtons = function(props) {
    return /*#__PURE__*/ _jsx(RNHeaderButtons, _object_spread({
        HeaderButtonComponent: HeaderButton
    }, props));
};
/**
 * @nosync
 */ export var HeaderItem = function(props) {
    // @ts-expect-error Our Icon component for Item accepts a different prop type
    return /*#__PURE__*/ _jsx(Item, _object_spread({}, props));
};
